import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const BreakWaiverRoutes = [
    {
        "url": "/brand/{brand_id:[0-9]*}/break-waivers?template_id",
        "name": "appLayout.harriSH.break-waivers",
        "type": "frontend",
        "reloadOnSearch": false,
        "loginRequired": true,
        "showGlobalSearch": true,
        "component": 'manageBreakWaivers',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/break-waivers/break-waivers.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/brand/{brand_id:[0-9]*}/break-waivers/${hmapPathParamRegex}?template_id`,
        "name": "appLayout.harriSH.access-portal.break-waivers",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "reloadOnSearch": false,
        "loginRequired": true,
        "showGlobalSearch": true,
        "component": 'manageBreakWaivers',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/break-waivers/break-waivers.downgrade.module");
                }
            },
        ]
    }
];
//# sourceMappingURL=break-waiver.routes.js.map